import { render, staticRenderFns } from "./FormReward.vue?vue&type=template&id=5a77f473&scoped=true&"
import script from "./FormReward.vue?vue&type=script&lang=js&"
export * from "./FormReward.vue?vue&type=script&lang=js&"
import style0 from "./FormReward.vue?vue&type=style&index=0&id=5a77f473&scoped=true&lang=css&"
import style1 from "./FormReward.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a77f473",
  null
  
)

export default component.exports